import { DSButton } from '@repo/design-system/index'
import { useState } from 'react'
import { n_ai_tutor } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { ActivityScreen, Box, Nudge } from '../Common'

const ChooseActivity = ({
  content = [],
  done,
  setDone,
  nextActivity,
  context,
  context_kor,
  context_ja,
  addFail,
  retry,
  idx,
}: {
  content?: any[]
  done: boolean
  setDone: (done: boolean) => void
  nextActivity: () => void
  context: string
  context_kor: string
  context_ja: string
  addFail: () => void
  retry?: boolean
  idx?: any
}) => {
  const { t, locale } = useTranslation()
  const [selected, setSelected] = useState(-1)
  const [solved, setSolved] = useState(null)
  const [explanation, setExplanation] = useState('')

  const submit = () => {
    if (selected === -1) return
    if (solved === 'done') return

    if (content[selected].correct) {
      setSolved('done')
    } else {
      setSolved('fail')
      addFail()
    }
    if (locale === 'ko') {
      setExplanation(content[selected].explanation_kor)
    } else if (locale == 'ja') {
      setExplanation(content[selected].explanation_ja || content[selected].explanation)
    } else {
      setExplanation(content[selected].explanation)
    }
  }

  const getTranslatedContext = () => {
    if (locale === 'ko') {
      return context_kor
    } else if (locale === 'ja') {
      return context_ja || context
    } else {
      return context
    }
  }

  return (
    <ActivityScreen
      title={t(n_ai_tutor.study_activity.five_title)}
      solved={solved}
      nextActivity={nextActivity}
      explanation={explanation}
      retry={retry}
      idx={idx}
    >
      <Nudge title={t(n_ai_tutor.study_activity.label3)} className="Body2-16Md">
        <span>{getTranslatedContext()}</span>
      </Nudge>
      <div className="flex flex-row gap-[12px] items-start justify-center flex-wrap content-start self-stretch flex-1">
        {content.map((c, i) => (
          <Box
            key={i}
            onClick={() => !solved && setSelected(i)}
            active={selected === i}
            correct={solved && selected === i ? c.correct : null}
            bold
            white
          >
            {c.content}
          </Box>
        ))}
      </div>

      {!solved && (
        <div className="w-full sticky bottom-[20px] left-[0px] mb-[12px]">
          <DSButton onClick={submit} disabled={selected === -1}>
            <DSButton.Label>{t(n_ai_tutor.study_activity.continue_btn)}</DSButton.Label>
          </DSButton>
        </div>
      )}
    </ActivityScreen>
  )
}

export default ChooseActivity
